import { Person } from "movieapi";
import * as React from "react";
import CrewTable from "./CrewTable";

export interface IChooseCrewProps {
  data: Person[] | undefined;
  handlePersonChange: (person: Person[]) => void;
}

export default class ChooseCrew extends React.Component<IChooseCrewProps, {}> {
  constructor(props: IChooseCrewProps) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <div>
        <p>Edit Crew</p>
        <CrewTable
          data={this.props.data}
          handlePersonChange={this.props.handlePersonChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ChooseCrew.tsx